import { i18n } from "../translate/i18n";

export const traditionalReadingOrderBibleArray = [
  {
    name: "genesis",
    bookAbbreviation: i18n.t("messages.bibleBooks.genesis.abbreviation"),
    startChapter: 1,
    endChapter: 50,
    chapters: 50,
    verses: 1533,
    testment: i18n.t("messages.bibleBooks.genesis.testament"),
    id: "genesis",
  },
  {
    name: "exodus",
    bookAbbreviation: i18n.t("messages.bibleBooks.exodus.abbreviation"),
    startChapter: 1,
    endChapter: 40,
    chapters: 40,
    verses: 1213,
    testment: i18n.t("messages.bibleBooks.exodus.testament"),
    id: "exodus",
  },
  {
    name: "leviticus",
    bookAbbreviation: i18n.t("messages.bibleBooks.leviticus.abbreviation"),
    startChapter: 1,
    endChapter: 27,
    chapters: 27,
    verses: 859,
    testment: i18n.t("messages.bibleBooks.leviticus.testament"),
    id: "leviticus",
  },
  {
    name: "numbers",
    bookAbbreviation: i18n.t("messages.bibleBooks.numbers.abbreviation"),
    startChapter: 1,
    endChapter: 36,
    chapters: 36,
    verses: 1288,
    testment: i18n.t("messages.bibleBooks.numbers.testament"),
    id: "numbers",
  },
  {
    name: "deuteronomy",
    bookAbbreviation: i18n.t("messages.bibleBooks.deuteronomy.abbreviation"),
    startChapter: 1,
    endChapter: 34,
    chapters: 34,
    verses: 959,
    testment: i18n.t("messages.bibleBooks.deuteronomy.testament"),
    id: "deuteronomy",
  },
  {
    name: "joshua",
    bookAbbreviation: i18n.t("messages.bibleBooks.joshua.abbreviation"),
    startChapter: 1,
    endChapter: 24,
    chapters: 24,
    verses: 658,
    testment: i18n.t("messages.bibleBooks.joshua.testament"),
    id: "joshua",
  },
  {
    name: "judges",
    bookAbbreviation: i18n.t("messages.bibleBooks.judges.abbreviation"),
    startChapter: 1,
    endChapter: 21,
    chapters: 21,
    verses: 619,
    testment: i18n.t("messages.bibleBooks.judges.testament"),
    id: "judges",
  },
  {
    name: "ruth",
    bookAbbreviation: i18n.t("messages.bibleBooks.ruth.abbreviation"),
    startChapter: 1,
    endChapter: 4,
    chapters: 4,
    verses: 85,
    testment: i18n.t("messages.bibleBooks.ruth.testament"),
    id: "ruth",
  },
  {
    name: "samuel1",
    bookAbbreviation: i18n.t("messages.bibleBooks.samuel1.abbreviation"),
    startChapter: 1,
    endChapter: 31,
    chapters: 31,
    verses: 811,
    testment: i18n.t("messages.bibleBooks.samuel1.testament"),
    id: "samuel1",
  },
  {
    name: "samuel2",
    bookAbbreviation: i18n.t("messages.bibleBooks.samuel2.abbreviation"),
    startChapter: 1,
    endChapter: 24,
    chapters: 24,
    verses: 695,
    testment: i18n.t("messages.bibleBooks.samuel2.testament"),
    id: "samuel2",
  },
  {
    name: "kings1",
    bookAbbreviation: i18n.t("messages.bibleBooks.kings1.abbreviation"),
    startChapter: 1,
    endChapter: 22,
    chapters: 22,
    verses: 817,
    testment: i18n.t("messages.bibleBooks.kings1.testament"),
    id: "kings1",
  },
  {
    name: "kings2",
    bookAbbreviation: i18n.t("messages.bibleBooks.kings2.abbreviation"),
    startChapter: 1,
    endChapter: 25,
    chapters: 25,
    verses: 719,
    testment: i18n.t("messages.bibleBooks.kings2.testament"),
    id: "kings2",
  },
  {
    name: "chronicles1",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles1.abbreviation"),
    startChapter: 1,
    endChapter: 29,
    chapters: 29,
    verses: 942,
    testment: i18n.t("messages.bibleBooks.chronicles1.testament"),
    id: "chronicles1",
  },
  {
    name: "chronicles2",
    bookAbbreviation: i18n.t("messages.bibleBooks.chronicles2.abbreviation"),
    startChapter: 1,
    endChapter: 36,
    chapters: 36,
    verses: 822,
    testment: i18n.t("messages.bibleBooks.chronicles2.testament"),
    id: "chronicles2",
  },
  {
    name: "ezra",
    bookAbbreviation: i18n.t("messages.bibleBooks.ezra.abbreviation"),
    startChapter: 1,
    endChapter: 10,
    chapters: 10,
    verses: 280,
    testment: i18n.t("messages.bibleBooks.ezra.testament"),
    id: "ezra",
  },
  {
    name: "nehemiah",
    bookAbbreviation: i18n.t("messages.bibleBooks.nehemiah.abbreviation"),
    startChapter: 1,
    endChapter: 13,
    chapters: 13,
    verses: 406,
    testment: i18n.t("messages.bibleBooks.nehemiah.testament"),
    id: "nehemiah",
  },
  {
    name: "esther",
    bookAbbreviation: i18n.t("messages.bibleBooks.esther.abbreviation"),
    startChapter: 1,
    endChapter: 10,
    chapters: 10,
    verses: 167,
    testment: i18n.t("messages.bibleBooks.esther.testament"),
    id: "esther",
  },
  {
    name: "job",
    bookAbbreviation: i18n.t("messages.bibleBooks.job.abbreviation"),
    startChapter: 1,
    endChapter: 42,
    chapters: 42,
    verses: 1070,
    testment: i18n.t("messages.bibleBooks.job.testament"),
    id: "job",
  },
  {
    name: "psalms",
    bookAbbreviation: i18n.t("messages.bibleBooks.psalms.abbreviation"),
    startChapter: 1,
    endChapter: 150,
    chapters: 150,
    verses: 2461,
    testment: i18n.t("messages.bibleBooks.psalms.testament"),
    id: "psalms",
  },
  {
    name: "proverbs",
    bookAbbreviation: i18n.t("messages.bibleBooks.proverbs.abbreviation"),
    startChapter: 1,
    endChapter: 31,
    chapters: 31,
    verses: 915,
    testment: i18n.t("messages.bibleBooks.proverbs.testament"),
    id: "proverbs",
  },
  {
    name: "ecclesiastes",
    bookAbbreviation: i18n.t("messages.bibleBooks.ecclesiastes.abbreviation"),
    startChapter: 1,
    endChapter: 12,
    chapters: 12,
    verses: 222,
    testment: i18n.t("messages.bibleBooks.ecclesiastes.testament"),
    id: "ecclesiastes",
  },
  {
    name: "solomonsongof",
    bookAbbreviation: i18n.t("messages.bibleBooks.solomonsongof.abbreviation"),
    startChapter: 1,
    endChapter: 8,
    chapters: 8,
    verses: 117,
    testment: i18n.t("messages.bibleBooks.solomonsongof.testament"),
    id: "solomonsongof",
  },
  {
    name: "isaiah",
    bookAbbreviation: i18n.t("messages.bibleBooks.isaiah.abbreviation"),
    startChapter: 1,
    endChapter: 66,
    chapters: 66,
    verses: 1292,
    testment: i18n.t("messages.bibleBooks.isaiah.testament"),
    id: "isaiah",
  },
  {
    name: "jeremiah",
    bookAbbreviation: i18n.t("messages.bibleBooks.jeremiah.abbreviation"),
    startChapter: 1,
    endChapter: 52,
    chapters: 52,
    verses: 1364,
    testment: i18n.t("messages.bibleBooks.jeremiah.testament"),
    id: "jeremiah",
  },
  {
    name: "lamentations",
    bookAbbreviation: i18n.t("messages.bibleBooks.lamentations.abbreviation"),
    startChapter: 1,
    endChapter: 5,
    chapters: 5,
    verses: 154,
    testment: i18n.t("messages.bibleBooks.lamentations.testament"),
    id: "lamentations",
  },
  {
    name: "ezekiel",
    bookAbbreviation: i18n.t("messages.bibleBooks.ezekiel.abbreviation"),
    startChapter: 1,
    endChapter: 48,
    chapters: 48,
    verses: 1273,
    testment: i18n.t("messages.bibleBooks.ezekiel.testament"),
    id: "ezekiel",
  },
  {
    name: "daniel",
    bookAbbreviation: i18n.t("messages.bibleBooks.daniel.abbreviation"),
    startChapter: 1,
    endChapter: 12,
    chapters: 12,
    verses: 357,
    testment: i18n.t("messages.bibleBooks.daniel.testament"),
    id: "daniel",
  },
  {
    name: "hosea",
    bookAbbreviation: i18n.t("messages.bibleBooks.hosea.abbreviation"),
    startChapter: 1,
    endChapter: 14,
    chapters: 14,
    verses: 197,
    testment: i18n.t("messages.bibleBooks.hosea.testament"),
    id: "hosea",
  },
  {
    name: "joel",
    bookAbbreviation: i18n.t("messages.bibleBooks.joel.abbreviation"),
    startChapter: 1,
    endChapter: 3,
    chapters: 3,
    verses: 73,
    testment: i18n.t("messages.bibleBooks.joel.testament"),
    id: "joel",
  },
  {
    name: "amos",
    bookAbbreviation: i18n.t("messages.bibleBooks.amos.abbreviation"),
    startChapter: 1,
    endChapter: 9,
    chapters: 9,
    verses: 146,
    testment: i18n.t("messages.bibleBooks.amos.testament"),
    id: "amos",
  },
  {
    name: "obadiah",
    bookAbbreviation: i18n.t("messages.bibleBooks.obadiah.abbreviation"),
    startChapter: 1,
    endChapter: 1,
    chapters: 1,
    verses: 21,
    testment: i18n.t("messages.bibleBooks.obadiah.testament"),
    id: "obadiah",
  },
  {
    name: "jonah",
    bookAbbreviation: i18n.t("messages.bibleBooks.jonah.abbreviation"),
    startChapter: 1,
    endChapter: 4,
    chapters: 4,
    verses: 48,
    testment: i18n.t("messages.bibleBooks.jonah.testament"),
    id: "jonah",
  },
  {
    name: "micah",
    bookAbbreviation: i18n.t("messages.bibleBooks.micah.abbreviation"),
    startChapter: 1,
    endChapter: 7,
    chapters: 7,
    verses: 105,
    testment: i18n.t("messages.bibleBooks.micah.testament"),
    id: "micah",
  },
  {
    name: "nahum",
    bookAbbreviation: i18n.t("messages.bibleBooks.nahum.abbreviation"),
    startChapter: 1,
    endChapter: 3,
    chapters: 3,
    verses: 47,
    testment: i18n.t("messages.bibleBooks.nahum.testament"),
    id: "nahum",
  },
  {
    name: "habakkuk",
    bookAbbreviation: i18n.t("messages.bibleBooks.habakkuk.abbreviation"),
    startChapter: 1,
    endChapter: 3,
    chapters: 3,
    verses: 56,
    testment: i18n.t("messages.bibleBooks.habakkuk.testament"),
    id: "habakkuk",
  },
  {
    name: "zephaniah",
    bookAbbreviation: i18n.t("messages.bibleBooks.zephaniah.abbreviation"),
    startChapter: 1,
    endChapter: 3,
    chapters: 3,
    verses: 53,
    testment: i18n.t("messages.bibleBooks.zephaniah.testament"),
    id: "zephaniah",
  },
  {
    name: "haggai",
    bookAbbreviation: i18n.t("messages.bibleBooks.haggai.abbreviation"),
    startChapter: 1,
    endChapter: 2,
    chapters: 2,
    verses: 38,
    testment: i18n.t("messages.bibleBooks.haggai.testament"),
    id: "haggai",
  },
  {
    name: "zechariah",
    bookAbbreviation: i18n.t("messages.bibleBooks.zechariah.abbreviation"),
    startChapter: 1,
    endChapter: 14,
    chapters: 14,
    verses: 211,
    testment: i18n.t("messages.bibleBooks.zechariah.testament"),
    id: "zechariah",
  },
  {
    name: "malachi",
    bookAbbreviation: i18n.t("messages.bibleBooks.malachi.abbreviation"),
    startChapter: 1,
    endChapter: 4,
    chapters: 4,
    verses: 55,
    testment: i18n.t("messages.bibleBooks.malachi.testament"),
    id: "malachi",
  },
  {
    name: "matthew",
    bookAbbreviation: i18n.t("messages.bibleBooks.matthew.abbreviation"),
    startChapter: 1,
    endChapter: 28,
    chapters: 28,
    verses: 1071,
    testment: i18n.t("messages.bibleBooks.matthew.testament"),
    id: "matthew",
  },
  {
    name: "mark",
    bookAbbreviation: i18n.t("messages.bibleBooks.mark.abbreviation"),
    startChapter: 1,
    endChapter: 16,
    chapters: 16,
    verses: 678,
    testment: i18n.t("messages.bibleBooks.mark.testament"),
    id: "mark",
  },
  {
    name: "luke",
    bookAbbreviation: i18n.t("messages.bibleBooks.luke.abbreviation"),
    startChapter: 1,
    endChapter: 24,
    chapters: 24,
    verses: 1151,
    testment: i18n.t("messages.bibleBooks.luke.testament"),
    id: "luke",
  },
  {
    name: "john",
    bookAbbreviation: i18n.t("messages.bibleBooks.john.abbreviation"),
    startChapter: 1,
    endChapter: 21,
    chapters: 21,
    verses: 879,
    testment: i18n.t("messages.bibleBooks.john.testament"),
    id: "john",
  },
  {
    name: "acts",
    bookAbbreviation: i18n.t("messages.bibleBooks.acts.abbreviation"),
    startChapter: 1,
    endChapter: 28,
    chapters: 28,
    verses: 1007,
    testment: i18n.t("messages.bibleBooks.acts.testament"),
    id: "acts",
  },
  {
    name: "romans",
    bookAbbreviation: i18n.t("messages.bibleBooks.romans.abbreviation"),
    startChapter: 1,
    endChapter: 16,
    chapters: 16,
    verses: 433,
    testment: i18n.t("messages.bibleBooks.romans.testament"),
    id: "romans",
  },
  {
    name: "corinthians1",
    bookAbbreviation: i18n.t("messages.bibleBooks.corinthians1.abbreviation"),
    startChapter: 1,
    endChapter: 16,
    chapters: 16,
    verses: 437,
    testment: i18n.t("messages.bibleBooks.corinthians1.testament"),
    id: "corinthians1",
  },
  {
    name: "corinthians2",
    bookAbbreviation: i18n.t("messages.bibleBooks.corinthians2.abbreviation"),
    startChapter: 1,
    endChapter: 13,
    chapters: 13,
    verses: 256,
    testment: i18n.t("messages.bibleBooks.corinthians2.testament"),
    id: "corinthians2",
  },
  {
    name: "galatians",
    bookAbbreviation: i18n.t("messages.bibleBooks.galatians.abbreviation"),
    startChapter: 1,
    endChapter: 6,
    chapters: 6,
    verses: 149,
    testment: i18n.t("messages.bibleBooks.galatians.testament"),
    id: "galatians",
  },
  {
    name: "ephesians",
    bookAbbreviation: i18n.t("messages.bibleBooks.ephesians.abbreviation"),
    startChapter: 1,
    endChapter: 6,
    chapters: 6,
    verses: 155,
    testment: i18n.t("messages.bibleBooks.ephesians.testament"),
    id: "ephesians",
  },
  {
    name: "philippians",
    bookAbbreviation: i18n.t("messages.bibleBooks.philippians.abbreviation"),
    startChapter: 1,
    endChapter: 4,
    chapters: 4,
    verses: 104,
    testment: i18n.t("messages.bibleBooks.philippians.testament"),
    id: "philippians",
  },
  {
    name: "colossians",
    bookAbbreviation: i18n.t("messages.bibleBooks.colossians.abbreviation"),
    startChapter: 1,
    endChapter: 4,
    chapters: 4,
    verses: 95,
    testment: i18n.t("messages.bibleBooks.colossians.testament"),
    id: "colossians",
  },
  {
    name: "thessalonians1",
    bookAbbreviation: i18n.t("messages.bibleBooks.thessalonians1.abbreviation"),
    startChapter: 1,
    endChapter: 5,
    chapters: 5,
    verses: 89,
    testment: i18n.t("messages.bibleBooks.thessalonians1.testament"),
    id: "thessalonians1",
  },
  {
    name: "thessalonians2",
    bookAbbreviation: i18n.t("messages.bibleBooks.thessalonians2.abbreviation"),
    startChapter: 1,
    endChapter: 3,
    chapters: 3,
    verses: 47,
    testment: i18n.t("messages.bibleBooks.thessalonians2.testament"),
    id: "thessalonians2",
  },
  {
    name: "timothy1",
    bookAbbreviation: i18n.t("messages.bibleBooks.timothy1.abbreviation"),
    startChapter: 1,
    endChapter: 6,
    chapters: 6,
    verses: 113,
    testment: i18n.t("messages.bibleBooks.timothy1.testament"),
    id: "timothy1",
  },
  {
    name: "timothy2",
    bookAbbreviation: i18n.t("messages.bibleBooks.timothy2.abbreviation"),
    startChapter: 1,
    endChapter: 4,
    chapters: 4,
    verses: 83,
    testment: i18n.t("messages.bibleBooks.timothy2.testament"),
    id: "timothy2",
  },
  {
    name: "titus",
    bookAbbreviation: i18n.t("messages.bibleBooks.titus.abbreviation"),
    startChapter: 1,
    endChapter: 3,
    chapters: 3,
    verses: 46,
    testment: i18n.t("messages.bibleBooks.titus.testament"),
    id: "titus",
  },
  {
    name: "philemon",
    bookAbbreviation: i18n.t("messages.bibleBooks.philemon.abbreviation"),
    startChapter: 1,
    endChapter: 1,
    chapters: 1,
    verses: 25,
    testment: i18n.t("messages.bibleBooks.philemon.testament"),
    id: "philemon",
  },
  {
    name: "hebrews",
    bookAbbreviation: i18n.t("messages.bibleBooks.hebrews.abbreviation"),
    startChapter: 1,
    endChapter: 13,
    chapters: 13,
    verses: 303,
    testment: i18n.t("messages.bibleBooks.hebrews.testament"),
    id: "hebrews",
  },
  {
    name: "james",
    bookAbbreviation: i18n.t("messages.bibleBooks.james.abbreviation"),
    startChapter: 1,
    endChapter: 5,
    chapters: 5,
    verses: 108,
    testment: i18n.t("messages.bibleBooks.james.testament"),
    id: "james",
  },
  {
    name: "peter1",
    bookAbbreviation: i18n.t("messages.bibleBooks.peter1.abbreviation"),
    startChapter: 1,
    endChapter: 5,
    chapters: 5,
    verses: 105,
    testment: i18n.t("messages.bibleBooks.peter1.testament"),
    id: "peter1",
  },
  {
    name: "peter2",
    bookAbbreviation: i18n.t("messages.bibleBooks.peter2.abbreviation"),
    startChapter: 1,
    endChapter: 3,
    chapters: 3,
    verses: 61,
    testment: i18n.t("messages.bibleBooks.peter2.testament"),
    id: "peter2",
  },
  {
    name: "john1",
    bookAbbreviation: i18n.t("messages.bibleBooks.john1.abbreviation"),
    startChapter: 1,
    endChapter: 5,
    chapters: 5,
    verses: 105,
    testment: i18n.t("messages.bibleBooks.john1.testament"),
    id: "john1",
  },
  {
    name: "john2",
    bookAbbreviation: i18n.t("messages.bibleBooks.john2.abbreviation"),
    startChapter: 1,
    endChapter: 1,
    chapters: 1,
    verses: 13,
    testment: i18n.t("messages.bibleBooks.john2.testament"),
    id: "john2",
  },
  {
    name: "john3",
    bookAbbreviation: i18n.t("messages.bibleBooks.john3.abbreviation"),
    startChapter: 1,
    endChapter: 1,
    chapters: 1,
    verses: 15,
    testment: i18n.t("messages.bibleBooks.john3.testament"),
    id: "john3",
  },
  {
    name: "jude",
    bookAbbreviation: i18n.t("messages.bibleBooks.jude.abbreviation"),
    startChapter: 1,
    endChapter: 1,
    chapters: 1,
    verses: 25,
    testment: i18n.t("messages.bibleBooks.jude.testament"),
    id: "jude",
  },
  {
    name: "revelation",
    bookAbbreviation: i18n.t("messages.bibleBooks.revelation.abbreviation"),
    startChapter: 1,
    endChapter: 22,
    chapters: 22,
    verses: 404,
    testment: i18n.t("messages.bibleBooks.revelation.testament"),
    id: "revelation",
  },
];
